function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 4,
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinejoin: "round",
  d: "M20.67 3.67H24A3.33 3.33 0 0127.33 7v23.33A3.34 3.34 0 0124 33.67H4a3.34 3.34 0 01-3.33-3.34V7A3.33 3.33 0 014 3.67h3.33"
}), /*#__PURE__*/React.createElement("rect", {
  width: 13.33,
  height: 6.67,
  x: 7.33,
  y: 0.33,
  stroke: "#333",
  strokeLinejoin: "round",
  rx: 1.67
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#23C386",
  d: "M31.33 12.76L20.08 24.02l-5.89-5.88"
}));

function SvgDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 38"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNSAzOCI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgPHBhdGggc3Ryb2tlPSIjMzMzIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNMjAuNjcsMy42NyBMMjQsMy42NyBDMjUuODM5MTA4MiwzLjY3IDI3LjMzLDUuMTYwODkxNzggMjcuMzMsNyBMMjcuMzMsMzAuMzMgQzI3LjMzLDMyLjE3MDczMjkgMjUuODQwNzI0NiwzMy42NjQ0ODg4IDI0LDMzLjY3IEw0LDMzLjY3IEMyLjE1OTI3NTM4LDMzLjY2NDQ4ODggMC42NywzMi4xNzA3MzI5IDAuNjcsMzAuMzMgTDAuNjcsNyBDMC42Nyw1LjE2MDg5MTc4IDIuMTYwODkxNzgsMy42NyA0LDMuNjcgTDcuMzMsMy42NyIvPgogICAgPHJlY3Qgd2lkdGg9IjEzLjMzIiBoZWlnaHQ9IjYuNjciIHg9IjcuMzMiIHk9Ii4zMyIgc3Ryb2tlPSIjMzMzIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiByeD0iMS42NyIvPgogICAgPHBvbHlsaW5lIHN0cm9rZT0iIzIzQzM4NiIgcG9pbnRzPSIzMS4zMyAxMi43NiAyMC4wOCAyNC4wMiAxNC4xOSAxOC4xNCIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgDocs as ReactComponent };